import { get, post, put, patch, del } from "./HttpClient";

export default {
  get,
  post,
  put,
  patch,
  delete: del,
};
